var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Mobile","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"1"},React.createElement("g",{"id":"Mobile-Nav-Closed","strokeWidth":"4","transform":"translate(-337.000000, -26.000000)"},React.createElement("g",{"id":"Atom/Icon/Leveling/Purple","transform":"translate(339.000000, 28.000000)"},React.createElement("g",{"id":"nav-menu","transform":"translate(0.000000, 0.500000)"},[React.createElement("path",{"id":"Line","d":"M0,0.25 L15,0.25","key":0}),React.createElement("path",{"id":"Line","d":"M0,8.25 L15,8.25","key":1}),React.createElement("path",{"id":"Line","d":"M0,16.25 L15,16.25","key":2})])))));
}

Menu.defaultProps = {"className":"block w-full h-full","version":"1.1","viewBox":"0 0 19 21"};

module.exports = Menu;

Menu.default = Menu;
